import { all, call, put, select, take, takeLatest } from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import fireToastError from '../../actions/toasts/fireToastError'
import {
  IRequestUpdateLogo,
  requestUpdateLogoAccepted,
} from '../../actions/userObject/profile/requestUpdateLogo'
import i18n from '../../i18n'
import { updateLogo as requestUpdate } from '../../models/Object'
import { getCalendarId } from '../../reducers/bookingCalendar/selectors/calendar'
import { UserProfileActions } from '../../reducers/userObject/actionNames'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'

function* updateLogo(action: IRequestUpdateLogo) {
  try {
    const actionNames = fetchActionsName(ActionNames.UpdateUserLogo)
    const calendarId = yield select(getCalendarId)
    const [userProfile] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, requestUpdate)),
    ])
    const object = yield call(userProfile.service, action.data, calendarId)
    yield put(requestUpdateLogoAccepted(object))
  } catch (e) {
    yield put(fireToastError(i18n.t('BBO_910_profil_wrong_image_format')))
  }
}

export default function* () {
  yield takeLatest(UserProfileActions.RequestUpdateUserProfileLogo, updateLogo)
}
